// Layer actions
const LayerActions = ({ className, ...restProps }) => {
  return (
    <div className="mm-pod-layer-element-actions">{restProps.children}</div>
  );
};

export default LayerActions;
